// Shared search constants used by the search bar and the calendar radius
// control so both stay in sync.

export const RADIUS_OPTIONS = [10, 25, 50, 100, 250];
export const DEFAULT_RADIUS_MILES = 25;
